/*
 * qty-break-price-sync.js — Lyvoi PDP
 * Mirrors the selected quantity-break (Single/Duo/Triple) bundle total + compare
 * into the MAIN product price block, so users get visual feedback on selection.
 * DISPLAY-ONLY. Never touches the add-to-cart form / submit / cart logic.
 * Fully wrapped in try/catch: any failure is silent and cannot break ATC.
 * Added 2026-06-22 to fix Clarity dead-clicks on the bundle selector.
 */
(function () {
  'use strict';
  function sync() {
    try {
      var pc = document.querySelector('.price__container');
      if (!pc) return;
      var r = document.querySelector('input[name="quantity"]:checked');
      if (!r) return;
      var label = document.querySelector('label[for="' + r.id + '"]');
      if (!label) return;
      var cardSale = label.querySelector('.quantity-break__price');
      if (!cardSale) return;
      var sale = cardSale.textContent.trim();
      if (!/\$\s*[\d,]/.test(sale)) return; // safety: only act on a real price
      pc.querySelectorAll('.main-price').forEach(function (el) {
        el.textContent = ' ' + sale + ' ';
      });
      var cardCmp = label.querySelector('.quantity-break__compare-price');
      var cmpEl = pc.querySelector('.price__compare-price');
      if (cmpEl && cardCmp) {
        var cmp = cardCmp.textContent.trim();
        if (/\$\s*[\d,]/.test(cmp)) cmpEl.textContent = ' ' + cmp + ' ';
      }
    } catch (e) { /* silent — never break the page */ }
  }
  function boot() { setTimeout(sync, 800); }
  try {
    // re-sync on bundle change (capture phase, passive) and on variant change
    document.addEventListener('change', function (e) {
      if (e && e.target && e.target.name === 'quantity') setTimeout(sync, 60);
      else if (e && e.target && /options\[/.test(e.target.name || '')) setTimeout(sync, 250);
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* silent */ }
})();
